<template>
  <div>
    <div style="padding: 10px; background: #fff">
      <zk-button-group
        groupName="auth"
        @Auth="showAuthDia"
        @AddUser="showAddUserDia"
      ></zk-button-group>
    </div>
    <zk-table :height="500" :columns="columns" :data="userList"></zk-table>

    <el-dialog
      :title="$t('role.addUser')"
      :visible.sync="userTransferDia"
      width="55%"
      center
    >
      <zk-user-transfer
        ref="userTransfer"
        :selectedData="selectedData"
      ></zk-user-transfer>
      <span slot="footer" class="dialog-footer">
        <el-button @click="userTransferDia = false">{{
          $t('common.cancel')
        }}</el-button>
        <el-button type="primary" @click="saveUserToRole">{{
          $t('common.confirm')
        }}</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="$t('role.authorization')" :visible.sync="authDia">
      <zk-auth-tree
        :selectRoleId="selectRoleId"
        @authSuces="authDia = false"
        :authTree="authTree"
        :checkedkeys="checkedkeys"
        ref="authTree"
      ></zk-auth-tree>
      <span slot="footer" class="dialog-footer">
        <el-button @click="authDia = false">{{
          $t('common.cancel')
        }}</el-button>
        <el-button type="primary" @click="auth">{{
          $t('common.confirm')
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import * as authService from '../../../services/auth'
import { dateFormat, dateByTimestamp } from '../../../utils/index.js'
import { addUsersToRole } from '../../../services/role.js'
export default {
  name: 'ZkRoleUser',
  data() {
    let columns = [
      {
        label: this.$t('user.account'),
        prop: 'loginName'
      },
      {
        label: this.$t('user.userName'),
        prop: 'name',
        width: 100
      },
      {
        label: this.$t('user.registerTime'),
        prop: 'createTime',
        render: (h, params) => {
          return h(
            'span',
            dateFormat(dateByTimestamp(params.row.createTime), null)
          )
        }
      },
      {
        label: this.$t('user.status'),
        prop: 'status',
        width: 80,
        render: (h, params) => {
          return h('zk-dictionary-transform', {
            props: {
              value: params.row.status,
              type: 'status'
            }
          })
        }
      },
      {
        label: this.$t('common.operation'),
        prop: 'action',
        render: (h, params) => {
          let _self = this
          return h('zk-operate-bar', {
            props: {
              isTextBtn: true
            },
            on: {
              remove() {
                _self.removeRoleUser(params.row)
              }
            }
          })
        }
      }
    ]
    let selectedData = []
    return {
      columns,
      userTransferDia: false,
      authDia: false,
      userList: [],
      authTree: [],
      selectedData,
      checkedkeys: []
    }
  },
  props: {
    selectRoleId: {
      type: String,
      default: ''
    }
  },
  methods: {
    showAddUserDia() {
      if (this.selectRoleId === '') {
        this.$notify({
          title: this.$t('common.warningNotice'),
          message: this.$t('role.selectRoleToAddUserTip'),
          type: 'warning'
        })
        return
      }
      this.userTransferDia = true
    },
    showAuthDia() {
      if (this.selectRoleId === '') {
        this.$notify({
          title: this.$t('common.warningNotice'),
          message: this.$t('role.selectRoleToAuthorizeTip'),
          type: 'warning'
        })
        return
      }
      let params = {
        roleId: this.selectRoleId
      }
      authService.queryRoleResourceList(params).then((data) => {
        if (data.code === '00000000') {
          this.authTree = [this.$root.resourceTree]
          this.checkedkeys = data.payload.results.checkNode
        } else {
          this.$notify.error({
            title: this.$t('common.errorNotice'),
            message: data.message
          })
        }
      })
      this.authDia = true
    },
    auth() {
      this.$refs.authTree.updateRoleResource()
    },
    queryRoleUser(roleId) {
      // if(roleId===''){
      //   return
      // }
      let params = {
        roleId: roleId
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      authService
        .queryRoleUser(params)
        .then((data) => {
          this.userList = data.payload.results.userList
          this.selectedData = []
          this.userList.forEach((item) => {
            this.selectedData.push({
              key: item.id,
              label: item.loginName
            })
          })
          loading.close()
        })
        .catch((data) => {
          loading.close()
          this.$notify.error({
            title: this.$t('common.errorNotice'),
            message: data.message
          })
        })
    },
    saveUserToRole() {
      let _self = this
      let val = this.$refs.userTransfer.getSelect()
      if (val === '' || val.length < 1) {
        this.$notify({
          title: this.$t('common.errorNotice'),
          message: this.$t('role.selectUser'),
          type: 'warming'
        })
        return
      }
      addUsersToRole({
        roleId: this.selectRoleId,
        userIdArr: val
      })
        .then((data) => {
          this.queryRoleUser(this.selectRoleId)
          this.$notify({
            title: this.$t('common.success'),
            message: this.$t('common.addSuccess'),
            type: 'success'
          })
          this.userTransferDia = false
        })
        .catch((data) => {
          _self.$notify.error({
            title: this.$t('common.errorNotice'),
            message: data.message
          })
        })
    },
    removeRoleUser(rowObj) {
      let _this = this
      // 超级管理员下的admin不允许删除
      if (
        this.selectRoleId === 'superadministrator' &&
        rowObj.id === '00000000000000000000000000000000'
      ) {
        this.$message({
          type: 'error',
          message: this.$t('role.notDeleteAdmin')
        })
        return
      }
      this.$confirm(
        this.$tc('role.confirmDeleteUserTip', 1) +
          rowObj.name +
          this.$tc('role.confirmDeleteUserTip', 2),
        this.$t('common.warningNotice'),
        {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          let params = {
            userId: rowObj.id,
            roleId: this.selectRoleId
          }
          authService.removeUserRole(params).then((data) => {
            if (data.code === '00000000') {
              _this.queryRoleUser(this.selectRoleId)
            } else {
              this.$notify.error({
                title: this.$t('common.errorNotice'),
                message: data.message
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('common.cancelDelete')
          })
        })
    }
  },
  watch: {
    selectRoleId(value) {
      this.queryRoleUser(value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/cdpBase/baseComponents/roleUser/src/main.vue